export default __webpack_public_path__ + "static/media/flag.b8eb73a3.svg";